import { useDelayedRender } from "../core/hooks/useDelayedRender";

export const DelayedRender = ({ delay, children }: React.PropsWithChildren<{ delay: number }>) => useDelayedRender(delay)(() => children);
